import React, { Component } from 'react';
export default class BuildInfo extends Component {
  render () {
    return (
        <div>
            <div>NODE_ENV: { process.env.NODE_ENV }</div>
            <div>PUBLIC_URL: { process.env.PUBLIC_URL }</div>
            <div>WDS_SOCKET_HOST: { process.env.WDS_SOCKET_HOST }</div>
            <div>WDS_SOCKET_PATH: { process.env.WDS_SOCKET_PATH }</div>
            <div>WDS_SOCKET_PORT: { process.env.WDS_SOCKET_PORT }</div>
            <div>REACT_APP_ENVNAME: { process.env.REACT_APP_ENVNAME }</div>
            <div>REACT_APP_NAME: { process.env.REACT_APP_NAME }</div>
            <div>REACT_APP_VERSION: { process.env.REACT_APP_VERSION }</div>
            <div>REACT_APP_BUILD_DATE: { process.env.REACT_APP_BUILD_DATE}</div>
        </div>
    );
  }
}